/**
 * created by lei lei on 2020/5/29
 * 稿件追踪
 */
import React, {Component} from 'react';
import ActivityTrends from './ActivityTrends';
import {Empty, Modal, Tabs, Spin} from 'antd';
import {formateData, headers} from "../../../../actions";
import {permissionCheck, timeago} from "../../../../utils";
import {Scrollbars} from "react-custom-scrollbars";
import moreImg from "../commImg/diandiandian.png";
import Card from '../../../components/card/Card'

const { TabPane } = Tabs;

export default class FollowUpCorrespondenceComponents extends Component {
    static defaultProps = {}
    static propTypes = {}

    dataSource5 = [];
    dataSource6 = [];
    maxNum = 5;

    constructor(props) {
        super(props);
        this.state = {
            list:[],
            storyVisible: false,
            storyTitle : "",
            storyContent : "",
            loading: true,
        }
    }

    componentWillMount() {
    }

    componentDidMount()
    {
        this.initData();
    }
    componentWillUnmount() {
        this.setState = (state, callback) => {
            return;
        };
    }

    initData()
    {
        getMyRemindByType(9, (data)=>{
            if(data && data.data)
            {
                let list = data.data;
                {list.map((item, i)=>
                {
                    if(i < this.maxNum)
                    {
                        this.dataSource5.push(item);
                    }
                })}
                this.setState({
                    list : this.dataSource5,
                    loading: false
                })
            }
        });

        /*getMyRemindByType(6, (data)=>{
            if(data && data.data)
            {
                let list = data.data;
                {list.map((item, i)=>
                {
                    if(i < this.maxNum)
                    {
                        this.dataSource6.push(item);
                    }
                })}
            }
        });*/
    }

    callback(key) {
        this.setState({
            list : []
        })
        if(key == 1)
        {
            this.setState({
                list : this.dataSource5
            })
        }else {
            this.setState({
                list : this.dataSource6
            })
        }
    }

    render() {
        const { loading } = this.state;
        let isAuth = permissionCheck("pms:taskManuscriptFollowUp:viewAll");//是否展示任务完成情况
        if(!isAuth){
            return <div></div>
        }
        return (
            <Card title="任务稿件追踪" style={{ marginTop: 20}}>
                {
                    loading ? <div style={{height: 390, textAlign:'center', display:'flex', justifyContent: 'center', alignItems: 'center'}}><Spin /></div> : (
                        <div className={'activityContent'} style={(()=>{
                            return this.state.list.length === 0?{height: 390, textAlign:'center', display:'flex', justifyContent: 'center', alignItems: 'center'}:{height: 390}
                        })()}>
                            <Scrollbars
                                autoHeight
                                autoHeightMax={390}
                            >
                            {this.state.list.length === 0?<Empty/>:this.state.list.map((item,i)=>{
                                return(
                                    <  ActivityTrends key={i}
                                        currentUser={item.currentUser}
                                        dataSourrce={item.message}
                                        statusMark={item._status}
                                        timeMark={timeago(item.creatDate.time)}
                                        showStatus={true}
                                        onClickItem={(data)=>{
                                            this.showClickDialog(data);
                                        }}
                                    />
                                )
                            })}
                            </Scrollbars>
                        </div>
                    )
                }
                         <Modal
                     title={<div title={this.state.storyTitle} style={{overflow: 'hidden',
                         textOverflow: 'ellipsis',cursor:'pointer',
                         whiteSpace: 'nowrap',paddingRight:10}}>{this.state.storyTitle}</div>}
                     visible={this.state.storyVisible}
                     bodyStyle={{height:"570px"}}
                     width={860}
                     onCancel={this.handleCancel}
                     footer={null}
                     keyboard={false}
                 >
                 <Scrollbars
                     autoHide
                     style={{height:530}}
                 >
                     <div  dangerouslySetInnerHTML={{ __html: this.state.storyContent}}></div>
                 </Scrollbars>
                 </Modal>

                    </Card>
            // <div className={'ActivityTrendsComponents StaticMyDeskItemPaddingTop'} style={{width:'100%'}}>
            //     <div style={{background:'#FFFFFF',position:'relative'}}>
            //         <div style={{background:'white',width: '100%',float:'left',}}>
            //             <Tabs defaultActiveKey="1" onChange={(key)=>{this.callback(key)}}>
            //                 <TabPane tab="活动稿件追踪" key="1"></TabPane>
            //                 <TabPane tab="选题稿件追踪" key="2"></TabPane>
            //             {/* </Tabs>
            //           {/*  <div onClick={() => {
            //                 window.location.hash = this.ckqburl;
            //             }} style={{
            //                 fontSize: 13,
            //                 right: 0,
            //                 color: '#0050B3',
            //                 float: 'right',
            //                 marginRight: 20,
            //                 cursor: 'pointer',position:'absolute',top:-7
            //             }}>
            //                 <img src={moreImg} alt=""/>
            //             </div>*/} */}
            //         </div>
            //         <div style={{clear:'both'}}/>
            //         <Card>
            //         <div className={'activityContent'} style={(()=>{
            //             return this.state.list.length===0?{textAlign:'center'}:{}
            //         })()}>
            //             {this.state.list.length===0?<Empty/>:this.state.list.map((item,i)=>{
            //                 return(
            //                     <  ActivityTrends key={i}
            //                         dataSourrce={item.message}
            //                         statusMark={item._status}
            //                         timeMark={timeago(item.creatDate.time)}
            //                         showStatus={true}
            //                         onClickItem={(data)=>{
            //                             this.showClickDialog(data);
            //                         }}
            //                     />
            //                 )
            //             })}
            //         </div>

            //         </Card>
                   
            //     </div>
            //     <Modal
            //         title={this.state.storyTitle}
            //         visible={this.state.storyVisible}
            //         bodyStyle={{height:"570px"}}
            //         width={660}
            //         onCancel={this.handleCancel}
            //         footer={null}
            //         keyboard={false}
            //     >
            //     <Scrollbars
            //         autoHide
            //         style={{height:530, width:600}}
            //     >
            //         <span dangerouslySetInnerHTML={{ __html: this.state.storyContent}}></span>
            //     </Scrollbars>
            //     </Modal>
            // </div>
        )
    }

    handleCancel = () => {
        this.setState({
            storyVisible: false,
        });
    };

    showClickDialog(obj)
    {
        if(obj && obj.length >= 2)
        {
            if(obj[0] === "interview")
            {
                showInterview(obj[1], "");
            }
            if(obj[0] === "story")
            {
                getStoryById(obj[1], (data)=>{
                    if(data)
                    {
                        let itemData=data.content;
                        data.content= data.content.replace(/<embed[^>]*vsbmp4video=[^>]*>/ig, function(videoEmbed){
                            return videoEmbed.replace("<embed", "<video").replace(/(.*)src=\"[^\"]*\"(.*)vsburl=\"([^\"]*)\"(.*)/, "$1 $2 src=\"$3\" $4</video>");
                        }).replace(/<embed[^>]*vsbmp3audio=[^>]*>/ig, function(audioEmbed){
                            return audioEmbed.replace("<embed", "<audio").replace(/(.*)src=\"[^\"]*\"(.*)vsb_data=\"([^\"]*)\"(.*)/, "$1 $2 src=\"$3\"  controls=\"controls\" $4</audio>");
                        });



                        this.setState({
                            storyVisible : true,
                            storyTitle : data.title,
                            storyContent :  data.content
                        })
                    }
                });
            }
        }
    }
}

export const getMyRemindByType = (type, callBack)=> {
    let url = "/cm-sites-pms/remind/getMyRemindByType";
    fetch(url, {
        method: 'post',
        cache: 'no-cache',
        headers: headers,
        credentials: 'include',
        body: formateData({type})
    }).then(response => response.json()).then(data => {
        callBack(data);
    }).catch((error) => {
        console.error("actionError:getMyRemindByType",error);
        callBack("");
    })
}

export const getStoryById = (storyId, callBack)=> {
    let url = "/cm-sites-pms/storyNew/show";
    fetch(url, {
        method: 'post',
        cache: 'no-cache',
        headers: headers,
        credentials: 'include',
        body: formateData({storyId})
    }).then(response => response.json()).then(data => {
        callBack(data);
    }).catch((error) => {
        console.error("actionError:getStoryById",error);
        callBack("");
    })
}

function showInterview(interviewId, title)
{
    window.layer.open({
        id: "",
        //btn: ['确定', '关闭'],
        btn: null,
        type: 2,//0（信息框，默认）1（页面层）2（iframe层）3（加载层）4（tips层）。
        content: "/cm-sites/pms/interviewTask/interviewTaskdetail.html?interviewId=" + interviewId,
        title : title,
        resize : true,
        shade : 0.001,	//遮罩
        //shade : 0,
        //shadeClose : true,	//点击遮罩是否关闭
        zIndex : 100,
        area: [parseInt(window.$(window).width() * 0.9) + 'px',parseInt(window.$(window).height() * 0.9) + 'px'],
        yes : function(index, layero) {

        },
        end: function () {
        }
    })
}